// mutations

import types from './mutation-types';

const mutations = {
  // 设置是否在加载
  [types.SET_LOADING](state, platform) {
    state.isLoading = platform;
  },

  // 查看协议
  [types.LOOK_PROTOCOL](state, flag) {
    state.isProtocol = flag;
  },

  // 设置全局价格
  [types.SET_PRICE](state, data) {
    state.price = data;
  },

  // 设置banner
  [types.SET_BANNERURL](state, data) {
    state.bannerUrl = data;
  },

  // 设置在线时间
  [types.SET_ONLINETIME](state, data) {
    state.onlineTime = data;
  },

  // 设置新消息状态
  [types.SET_NEWMESSAGE](state, flag) {
    state.newMessageStaus = flag;
  },

  // 是否有问题
  [types.NO_QUESTION](state, flag) {
    state.isNoQuestion = flag;
  },

  // 更新顶部导航
  [types.UPDATE_NAV](state, obj) {
    state.navBar = Object.assign(state.navBar, obj);
  },

  // 更新问题
  [types.UPDATE_QUESTION](state, obj) {
    state.question.describe = obj.describe;
    state.question.count = obj.count;
    state.question.status = obj.status;
  },

  // 更新问题
  [types.UPDATE_QUESTION_STATUS](state, obj) {
    state.question.status = obj.status;
  },

  // 更新问诊id
  [types.INTERROGATION_ID](state, obj) {
    state.question.id = obj;
  },

  // 我的服务列表
  [types.QUESTION_LIST](state, obj) {
    if (obj.isUpdate) {
      state.lists = state.lists.splice(0, 20, obj.data);
    } else {
      state.lists = state.lists.concat(obj.data);
    }
  },

  // 医生详情
  [types.DOCTOR_DETAIL](state, obj) {
    state.doctor = obj;
  },

  // 是否评价
  [types.IS_RATE](state, type) {
    state.isRate = type;
  },

  // 设置token
  [types.SET_TOKEN](state, val) {
    state.token = val;
  },

  // 获取后台配置的静态数据
  [types.GET_CONSTANT_DATA](state, data) {
    state.constantData = data;
  },
  // 会员状态 memberState
  [types.MEMBER_STATE](state, data) {
    state.memberState = data;
  },
  // 会员状态 memberState
  [types.GOODS_VIP_INFO](state, data) {
    state.goodsVipInfo = data;
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/stores/mutations.js